<template>
  <div class="comp__">
    <a-form
      hideRequiredMark
      :form="form"
      :class="_i18n.locale == 'en-us' ? 'label_w208_' : ''"
      class="horizontal_form_ label_w108_"
    >
      <a-form-item :label="$t('cashierDesk[20]') || '真实姓名'">
        <a-input
          v-decorator="[
            'acctName',
            {
              rules: [
                {
                  required: true,
                  message: $t('cashierDesk[10]') || '请输入真实姓名'
                }
              ]
            }
          ]"
          class="w331_"
          :placeholder="$t('cashierDesk[20]') || '请输入真实姓名'"
        ></a-input>
      </a-form-item>
      <a-form-item :label="$t('cashierDesk[22]') || '证件类型'">
        <a-select
          class="w331_"
          v-decorator="[
            'idType',
            {
              rules: [
                {
                  required: true,
                  message: $t('cashierDesk[23]') || '请选择证件类型'
                }
              ]
            }
          ]"
          :placeholder="$t('cashierDesk[23]') || '请选择证件类型'"
        >
          <a-select-option
            v-for="item in idTypeOptions"
            :key="item.value"
            :value="item.value"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('cashierDesk[24]') || '证件号'">
        <a-input
          v-decorator="[
            'idNo',
            {
              rules: [
                {
                  required: true,
                  message: $t('cashierDesk[24]') || '请输入证件号'
                }
              ]
            }
          ]"
          class="w331_"
          :placeholder="$t('cashierDesk[24]') || '请输入证件号'"
        ></a-input>
      </a-form-item>
      <a-form-item
        class="bank_select_wrap_"
        :label="$t('cashierDesk[25]') || '银行卡号'"
      >
        <label v-if="cardTypeLabel" class="card_label_">{{
          cardTypeLabel
        }}</label>
        <a-input
          @blur="handleCardNoBlur"
          :placeholder="$t('cashierDesk[6]') || '请输入银行卡号'"
          v-decorator="[
            'cardNo',
            {
              rules: [
                {
                  required: true,
                  message: $t('cashierDesk[6]') || '请输入银行卡号'
                }
              ]
            }
          ]"
          class="w331_"
        ></a-input>
        <a-popover overlayClassName="no_pd_" placement="bottom" trigger="click">
          <template slot="title">
            <ul class="tabs_">
              <li
                @click="handleChangeCardType(1)"
                :class="cardType == 1 ? 'active_' : ''"
                class="item_"
              >
                {{ $t("cashierDesk[26]") || "储蓄卡" }}
              </li>
              <li
                @click="handleChangeCardType(2)"
                :class="cardType == 2 ? 'active_' : ''"
                class="item_"
              >
                {{ $t("cashierDesk[27]") || "信用卡" }}
              </li>
            </ul>
          </template>
          <template slot="content">
            <div class="bank_content_">
              <!-- <ul class="right_">
                          <li @click="handleLetterClick(item)" class="item_" v-for="item in letters">
                              {{item}}
                          </li>
                      </ul> -->
              <div ref="bankWrap" class="bank_wrap_">
                <ul class="bank_list_">
                  <li
                    :class="item.key + '_'"
                    v-for="(item, index) in list"
                    class="item_"
                  >
                    <img
                      class="img_"
                      :src="'/pcadmin/bank/' + (index + 1) + '.jpg'"
                    />
                    <div class="info_">
                      <h5 class="name_">{{ item.name }}</h5>
                      <p class="desc_">{{ item.limit }}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </template>
          <a class="mrg_l10_">{{ $t("cashierDesk[28]") || "查看支持银行" }}</a>
        </a-popover>
      </a-form-item>
      <template v-if="showCreditCardInput">
        <a-form-item :label="$t('cashierDesk[29]') || '卡有效期'">
          <a-input
            v-decorator="[
              'validDate',
              {
                rules: [
                  {
                    required: true,
                    message: $t('cashierDesk[20]') || '请输入卡有效期'
                  }
                ]
              }
            ]"
            :placeholder="$t('cashierDesk[20]') || '月/年 如09/23'"
            class="w331_"
          ></a-input>
          <svg
            @click="handleShowTipsModal"
            class="i_question_"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="60"
            height="60"
            viewBox="0 0 30 30"
          >
            <image
              id="帮助"
              width="30"
              height="30"
              xlink:href="data:img/png;base64,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"
            />
          </svg>
        </a-form-item>
        <a-form-item :label="$t('cashierDesk[30]') || '卡验证码'">
          <a-input
            v-decorator="[
              'cvv2',
              {
                rules: [
                  {
                    required: true,
                    message: $t('cashierDesk[31]') || '请输入卡验证码'
                  }
                ]
              }
            ]"
            :placeholder="$t('cashierDesk[33]') || '签名栏最后三位'"
            class="w331_"
          ></a-input>
          <svg
            @click="handleShowTipsModal"
            class="i_question_"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="60"
            height="60"
            viewBox="0 0 30 30"
          >
            <image
              id="帮助"
              width="30"
              height="30"
              xlink:href="data:img/png;base64,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"
            />
          </svg>
        </a-form-item>
      </template>
      <a-form-item :label="$t('cashierDesk[7]') || '银行预留手机'">
        <a-input
          v-decorator="[
            'mobile',
            {
              rules: [
                {
                  required: true,
                  message: $t('cashierDesk[8]') || '请输入银行预留手机'
                }
              ]
            }
          ]"
          :placeholder="$t('cashierDesk[8]') || '请输入银行预留手机号'"
          class="w331_"
        ></a-input>
      </a-form-item>
      <a-form-item :label="$t('cashierDesk[9]') || '短信验证码'">
        <a-input
          v-decorator="['smsCode']"
          :placeholder="$t('cashierDesk[10]') || '请输入验证码'"
          class="w331_"
        ></a-input>
        <a @click="handleGetCode" class="btn_send_">
          {{
            count > 0
              ? ($t("cashierDesk[40]") || "重新发送 ") + count + "s"
              : $t("cashierDesk[15]") || "获取验证码"
          }}
        </a>
      </a-form-item>
      <a-form-item class="item_hide_label_" label=" ">
        <div class="checked_label_ mrg_t10_">
          <a-checkbox
            :checked="agreed"
            @change="e => (agreed = e.target.checked)"
            class="checkbox_"
          ></a-checkbox
          >{{ $t("cashierDesk[34]") || "已阅读并同意"
          }}<a @click="$emit('showAgreement')">{{
            $t("cashierDesk[35]") || "《快捷支付协议》"
          }}</a>
        </div>
        <div class="checked_label_">
          <a-checkbox
            :checked="bindCardFlag"
            @change="e => (bindCardFlag = e.target.checked)"
            class="checkbox_"
          ></a-checkbox
          >{{ $t("cashierDesk[13]") || "保存至常用卡" }}
        </div>
      </a-form-item>
      <a-form-item class="item_hide_label_" label=" ">
        <a-button @click="handleSubmit" class="btn_confirm_" type="primary">{{
          $t("cashierDesk[36]") || "确认"
        }}</a-button>
        <a-button
          @click="$emit('cancel')"
          class="btn_confirm_ mrg_l10_"
          type="primary"
          ghost
          >{{ $t("cashierDesk[37]") || "取消" }}</a-button
        >
      </a-form-item>
    </a-form>
  </div>
</template>
<style lang="scss" scoped>
.comp__ {
  padding-top: 20px;
  .checked_label_ {
    line-height: 22px;
  }
  .i_question_ {
    position: absolute;
    top: 6px;
    right: -20px;
    width: 12px;
    height: 12px;
  }
}
.bank_content_ {
  position: relative;
  .right_ {
    position: absolute;
    top: 20px;
    right: 14px;
    padding: 0;
    margin: 0;
    list-style: none;
    text-align: center;
    z-index: 666;
    cursor: pointer;

    .item_ {
      font-size: 10px;
      font-family: MicrosoftYaHeiUI;
      color: #999999;
      line-height: 14px;
    }
  }
  .bank_wrap_ {
    width: 650px;
    overflow-x: hidden;
    overflow-y: auto;
    position: relative;
    .img_ {
      width: 35px;
      height: 35px;
    }
  }
  .bank_list_ {
    padding: 0;
    padding-top: 20px;
    width: 680px;
    .item_ {
      display: inline-block;
      vertical-align: top;
      line-height: 19px;
      margin-bottom: 18px;
      overflow: hidden;
      width: 33.33%;

      .img_ {
        width: 35px;
        height: 35px;
        margin-right: 10px;
        vertical-align: top;
      }
      .info_ {
        display: inline-block;
      }
      .name_ {
        font-size: 14px;
        font-family: MicrosoftYaHeiUI;
        color: #394155;
        margin: 0;
      }
      .desc_ {
        font-size: 12px;
        font-family: MicrosoftYaHeiUI;
        color: #999999;
        margin: 0;
      }
    }
    &::after {
      display: block;
      content: "";
      clear: both;
    }
  }
}
.tabs_ {
  list-style: none;
  display: flex;
  padding: 0;
  margin: 0;

  .item_ {
    width: 81px;
    line-height: 48px;
    text-align: center;
    cursor: pointer;
    &.active_ {
      color: #2c5acc;
    }
  }
}
.mrg_t10_ {
  margin-top: 10px;
}
.mrg_l10_ {
  margin-left: 10px;
}
.checkbox_ {
  margin-right: 12px;
}
.w331_ {
  width: 331px;
}
.w120_ {
  width: 140px;
}
.btn_confirm_ {
  margin-top: 30px;
  width: 110px;
  height: 40px;
  border-radius: 2px;
}
.card_label_ {
  position: absolute;
  z-index: 666;
  top: -2px;
  left: 216px;
  display: inline-block;
  padding: 3px 4px;
  line-height: 16px;
  background: #54587b;
  font-size: 9px;
  font-family: MicrosoftYaHeiUI;
  color: #ffffff;
  background: #dec9a5;
  border-radius: 2px;
}
.btn_send_ {
  position: absolute;
  top: -10px;
  left: 241px;
  font-size: 14px;
  font-family: MicrosoftYaHeiUI;
  color: #2c5acc;
}
</style>
<script>
import bigBankList from "../bigBankList.json";
import bankList from "../bankList.json";
import api from "@/utils/api";
import pinyin from "js-pinyin";

const regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;

function generateBigLetter() {
  var str = [];
  for (var i = 65; i < 91; i++) {
    str.push(String.fromCharCode(i));
  }
  return str;
}
const letters = generateBigLetter();

let bankListSort = bigBankList
  .map(item => {
    const a = item.name.substr(0, 1);
    let key = pinyin.getCamelChars(a).substring(0, 1);
    const arr = ["C"];
    if (["重", "长"].indexOf(a) > -1) {
      key = arr[0];
    }
    return {
      ...item,
      key
    };
  })
  .sort((b, a) => {
    return b.key > a.key ? 1 : -1;
  });
const allList = bankListSort;
console.log(allList, "allList -> ");

export default {
  data() {
    const idTypeOptions = [
      { name: this.$t("labels[33]") || "身份证", value: "0" },
      { name: this.$t("labels[34]") || "护照", value: "2" },
      { name: this.$t("cashierDesk[38]") || "港澳通行证", value: "5" },
      { name: this.$t("cashierDesk[39]") || "台湾通行证", value: "6" }
    ];

    return {
      list: this.filterDataByType(1),
      letters,
      cardType: 1,
      showCreditCardInput: false,
      cardTypeLabel: "",
      form: this.$form.createForm(this),
      idTypeOptions,
      count: 0,
      agreed: false,
      bindCardFlag: false
    };
  },
  created() {},
  methods: {
    handleShowTipsModal() {
      this.$emit("showTipsModal");
    },
    handleLetterClick(letter) {
      let el = document.getElementsByClassName(letter + "_")[0];
      console.log(letter, el, "1");
      if (el) {
        console.log(el.offsetTop, el);
        this.$refs.bankWrap.scrollTo(0, el.offsetTop);
      }
    },
    checkIdNo(val) {
      return val && regIdCard.test(val);
    },
    startCountDown() {
      this.count = 59;
      let si = setInterval(() => {
        this.count--;
        if (this.count < 1) {
          clearInterval(si);
        }
      }, 1000);
    },
    trim(val) {
      return val && val.replace(/\s/g, "");
    },
    handleCardNoBlur(e) {
      const val = this.trim(e.target.value);
      if (!val) return;
      api
        .getBankCardInfo(val)
        .then(res => res.data)
        .then(data => {
          if (data.content.error) {
            return;
          }
          const { cardType } = data.content;
          this.cardTypeLabel = cardType;
          this.cardType = cardType == "借记卡" ? 1 : 2;
          this.showCreditCardInput = this.cardType == 1 ? false : true;
          this.currentCardBankInfo = {
            ...this.currentCardBankInfo,
            ...data.content
          };
        });
    },
    handleGetCode() {
      this.form.validateFields((err, values) => {
        if (!err) {
          if (!this.agreed) {
            this.$message.info("请勾选“已阅读并同意《快捷支付协议》”");
            return;
          }
          if (!this.checkIdNo(values.idNo)) {
            this.$message.info("身份证号码不正确");
            return;
          }
          api
            .agreementApply({
              ...values,
              acctType: this.cardType == 1 ? "00" : "02",
              acctNo: this.trim(values.cardNo)
            })
            .then(res => res.data)
            .then(data => {
              this.currentCardBankInfo = {
                cardNo: values.cardNo,
                ...data.content
              };
              this.startCountDown();
            });
        }
      });
    },
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          if (!values.smsCode || values.smsCode.length < 4) {
            this.$message.info("请填写短信验证码");
            return;
          }
          const acctType = this.cardType == 1 ? "00" : "02";
          api
            .agreementConfirm({
              ...values,
              acctType,
              acctNo: this.trim(this.currentCardBankInfo.cardNo),
              thpinfo: this.currentCardBankInfo.thpinfo,
              bindCardFlag: this.bindCardFlag ? "Y" : "N"
            })
            .then(res => res.data)
            .then(data => {
              const { agreeid, errmsg } = data.content;
              if (errmsg && !agreeid) {
                this.$message.info(errmsg);
                return;
              }
              this.$emit("ok", {
                ...this.currentCardBankInfo,
                ...data.content,
                acctType
              });
            });
        }
      });
    },
    filterDataByType(type) {
      const cardType =
        typeof type == "number" ? (type == 1 ? "DC" : "CC") : type;
      return allList.filter(item => item.cardType == cardType);
    },
    handleChangeCardType(type) {
      this.cardType = type;
      this.list = this.filterDataByType(type);
      this.$nextTick(() => {
        this.$refs.bankWrap.scrollTo(0, 0);
      });
    }
  }
};
</script>
